export default function (selector, width){
    return function (){
        let catfish = document.querySelector('[id^=' + selector + ']');
        let catfishStyle = {
            position: 'fixed',
            zIndex: '9999',
            bottom: '0',
            left: '0',
            right: '0',
            marginLeft: 'auto',
            marginRight: 'auto',
            width: width + 'px',
            display: 'block'
        }
        Object.assign(catfish.style, catfishStyle);

        let closeButton = document.createElement('p');
        closeButton.innerText = 'x';
        closeButton.id = 'desktop-catfish-close-button';

        let closeButtonStyle = {
            position: 'absolute',
            margin: '0',
            left: '93%',
            top: '-33px',
            backgroundColor: '#555',
            color: '#fff',
            fontSize: '21px',
            padding: '8px 10px 10px',
            border: 'none',
            borderRadius: '35px',
            textAlign: 'center',
            lineHeight: '0.5',
            userSelect: 'none',
            cursor: 'pointer',
        }
        Object.assign(closeButton.style, closeButtonStyle);

        closeButton.addEventListener('click', function () {
            catfish.remove();
        });

        catfish.appendChild(closeButton);
    }
}